import { useRef, useState } from 'react';

const useScrollableError = <T extends string = string>(
  selector?: string,
  extraMarginTop = 56,
) => {
  const [showError, setShowError] = useState(false);
  const [errorType, setErrorType] = useState<T | undefined>(undefined);
  const errorRef = useRef<HTMLDivElement>(null);

  const scrollToErrorStart = () => {
    if (errorRef.current) {
      const rect = errorRef.current.getBoundingClientRect();
      const scrollTop = window.pageYOffset + rect.top - 140 - extraMarginTop; // 140 is the header height
      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth',
      });
    }
  };

  const scrollToFirstError = () => {
    if (errorRef.current && selector) {
      const found = errorRef.current.querySelector(selector);
      if (found) {
        const rect = found.getBoundingClientRect();
        const scrollTop = window.pageYOffset + rect.top - 140 - extraMarginTop; // 140 is the header height
        window.scrollTo({
          top: scrollTop,
          behavior: 'smooth',
        });
      } else {
        // Fallback to container scroll if no specific error found
        scrollToErrorStart();
      }
    } else {
      // No selector provided, fall back to container scroll
      scrollToErrorStart();
    }
  };

  const showAndScrollToError = (type?: T) => {
    setErrorType(type);
    setShowError(true);
    scrollToErrorStart();
  };

  const showAndScrollToFirstError = () => {
    setShowError(true);
    scrollToFirstError();
  };

  const hideScrollableError = () => {
    setShowError(false);
    setErrorType(undefined);
  };

  return {
    errorRef,
    showError,
    showAndScrollToError,
    showAndScrollToFirstError,
    hideScrollableError,
    errorType,
  };
};

export default useScrollableError;
